import { ChangeEvent, ReactNode, useMemo, useState } from "react"
import { DataTable, DataTablePageParams, DataTableRowClickEventParams } from "primereact/datatable"
import { Column } from "primereact/column"
import { Tooltip } from "primereact/tooltip"
import { InputText } from "primereact/inputtext"
import { useDebounce } from "../../../common/useDebounce"
import { GetOrderTemplatesRequestQuery, OrderTemplate } from "../../../api/types/order-template"
import { useOrderTemplates } from "../../../api/queries/order-templates/useOrderTemplates"
import { useOrderTemplateCreateOrderPostponed } from "../../../api/queries/order-templates/useOrderTemplateCreateOrder"
import { useNavigate } from "react-router-dom"

export default function OrderTemplateListOverlay() {
  const navigate = useNavigate()
  const [offset, setOffset] = useState<number>(0)
  const [limit, setLimit] = useState<number>(20)
  const createOrderTemplateOrder = useOrderTemplateCreateOrderPostponed()

  const onPage = ({ first, rows }: DataTablePageParams): void => {
    setOffset(first)
    setLimit(rows)
  }

  const onRowClick = async (row: DataTableRowClickEventParams) => {
    const data = await createOrderTemplateOrder.mutateAsync(row.data.uuid)
    navigate(`/orders/${data.results.orderCreate.uuid}/loading`)
  }

  const rowClassName = (orderTemplate: OrderTemplate) => ({
    "cursor-pointer": true,
  })

  const DELAY = 500

  // name
  const [name, setName] = useState<string>("")
  const onNameChange = (event: ChangeEvent<HTMLInputElement>): void => setName(event.target.value)
  const tName = (row: OrderTemplate): ReactNode => (
    <div className="flex align-items-center">
      {row.isDefault && (
        <>
          <Tooltip target=".pi-star" />
          <i className="pi pi-star mr-1 text-400" data-pr-tooltip="Výchozí šablona" style={{ fontSize: ".75rem" }} />
        </>
      )}
      {row.name}
    </div>
  )
  const fName = useDebounce(name, DELAY)
  const fNameEl = (): ReactNode => <InputText value={name} onChange={onNameChange}
    placeholder={"Název"} />

  let payload: GetOrderTemplatesRequestQuery = useMemo((): GetOrderTemplatesRequestQuery => ({
    limit,
    offset,
    fName,
    fIsDefaultFirst: true,
  }), [limit, offset, fName])

  const { data: orderTemplates, isLoading } = useOrderTemplates(payload)

  return (
    <DataTable
      emptyMessage={"Žádné záznamy"} className={"p-datatable-sm p-datatable-filters p-datatable-simple"}
      paginator={true} lazy={true} rows={limit} first={offset}
      totalRecords={orderTemplates?.results.totalCount}
      loading={isLoading} onPage={onPage} value={orderTemplates?.results.orderTemplateList}
      onRowClick={onRowClick} rowClassName={rowClassName} rowHover={true} stripedRows={true}
      paginatorTemplate={"FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"}
      filterDisplay={"row"}>

      <Column header={"Název"} body={tName}
        filter={true} filterElement={fNameEl} showFilterMenu={false}
        headerClassName="p-hidden" />
    </DataTable>
  )
}
